import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';


class CardRoom extends Component {

    render() {
        const rooms = this.props.rooms;
        const duration = this.props.duration;
        return (
            <div className="list-card-resvations">
                <div className="list-card-panel-seccion">
                    <div className="content-card-panel-seccion">
                        <div className="row list list2">
                            {rooms.map((room, index) => (
                                <div className="col-lg-6 col-md-6 col-sm-12 col-12 card-panel-rooms" key={index}>
                                    <div className="card-panel panel panel-default card">
                                        <div className="panel-heading" style={{ backgroundImage: "url('" + room.imagen + "')" }}>
                                        </div>
                                        <div className="card-panel-body">
                                            <div className="panel-body-title">
                                                <h4 className="ioscentro">{room.name.toUpperCase()}</h4>
                                            </div>
                                            <div className="panel-body-description">
                                                <div className="panel-description-text">
                                                    {room.descripcion.slice(0, 150)}{room.descripcion.length > 150 ? '...' : null}
                                                </div>
                                                <div className="panel-description-information">
                                                    <div className="contenedor-flexbox">
                                                        <div className="contenedor">
                                                            <i className="fa fa-users" aria-hidden="true">
                                                            </i>
                                                            Capacidad para {room.capacidad} personas.
                                                        </div>
                                                    </div>
                                                    <div className="contenedor-flexbox">
                                                        <div className="contenedor">
                                                            <i className="fa fa-usd" aria-hidden="true"></i>
                                                            {duration === '4' ? (
                                                                "Precio de Sala por 2 Horas $" + room.hrs_2
                                                            ) : (
                                                                duration === '8' ? (
                                                                    "Precio de Sala por 4 Horas $" + room.hrs_4
                                                                ) : (
                                                                    "Precio de Sala por un dia Completo $" + room.full_day
                                                                )
                                                            )}

                                                        </div>
                                                    </div>
                                                    <div className="contenedor-flexbox">
                                                        <div className="contenedor">
                                                            TIPO DE SALA  {room.tipo_sala}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel-body-bottom">
                                                <div className="panel-body form-group">
                                                    <button
                                                        onClick={() => this.props.handleBookRoomPlus(room.id)}
                                                        className="btn btn-block btn-primary btn-singup btn_create"
                                                        type="button">
                                                        Ver Detalles de la Sala y Reservar
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="panel-body-bottom">
                                                <div className="form-group">
                                                    <button
                                                        onClick={() => this.props.handleBookRoom(room.id)}
                                                        className="btn btn-block btn-primary btn-singup btn_create"
                                                        type="button">
                                                        Reservar y Pagar Sala
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(CardRoom);


// WEBPACK FOOTER //
// ./src/dashboard/store/Reservation/CardRoom.js